<template>
    <header
        id="header"
        class="app-header has-text-centered relative w-full z-40"
        :class="cssVariables['--nav-bg-color'] ? 'bg-nav-color' : 'bg-gradient'"
    >
        <div
            v-if="navImage"
            aria-hidden="true"
            class="w-full h-full absolute bg-center bg-cover"
            :style="'background-image:url(' + navImage + ')'"
        ></div>
        <img
            v-if="decorImage"
            class="opacity-75 is-block absolute app-decor"
            :src="decorImage"
            alt=" "
            aria-hidden="true"
        />

        <nav
            aria-label="site navigation"
            class="px-4 xl:px-8 2xl:container level w-full relative"
        >
            <div
                class="navbar-brand flex items-center justify-between w-full font-nav"
                :class="fontTouse"
                id="navigation-header"
            >
                <router-link
                    to="/"
                    tabindex="0"
                    class="logo-container pr-2 inline-flex top-0"
                    :class="{
                        'py-3': headerOptions.useLogoPadding
                    }"
                    aria-label="Home"
                >
                    <img
                        class="block object-contain-xx flex-none w-full"
                        :src="siteLogo"
                        :alt="logoDesc"
                    />
                </router-link>
                <!-- TODO:VMP-422 --comment for now and should be coming from config -->
                <!-- <div
                    class="opacity-75 is-block absolute app-header__celebration"
                ></div> -->

                <NavBar class="right-0" :cssVariables="cssVariables" />
            </div>
        </nav>
        <!-- <img
      class="opacity-75 is-block absolute app-header__celebration-2"
    src="../assets/images/celebration-2.svg" alt="" aria-hidden="true">-->
    </header>
</template>

<script lang="ts">
import Vue from "vue";
import NavBar from "@/components/header/navbar.vue";

export default Vue.extend({
    data() {
        return {
            isOpen: false,
            nav: "",
            bg: "",
            color: "",
            publicPath: process.env.BASE_URL,
            isReady: false
        };
    },
    components: {
        NavBar
    },
    computed: {
        /**
         * Computed
         */
        headerOptions(): boolean {
            return this.$store.getters.layoutOptions?.headerOptions || {};
        },

        fontTouse(): string {
            const options = this.$store.getters.getPageOptions("header") || {};
            return options.fontToUse;
        },

        siteLogo(): string {
            return this.$store.getters.logo;
        },

        mobileLogo(): string {
            return this.$store.getters.mobileLogo;
        },

        logoDesc(): string {
            return this.$store.getters.logoDesc;
        },

        decorImage(): string | boolean {
            if (this.$store.getters.decorImage) {
                return (
                    this.publicPath + "img/" + this.$store.getters.decorImage
                );
            }
            return false;
        },

        navImage(): string | boolean {
            if (this.$store.getters.navImage) {
                return (
                    this.publicPath +
                    "nav-images/" +
                    this.$store.getters.navImage
                );
            }
            return false;
        },

        cssVariables(): Record<string, string> {
            return this.$store.getters.cssVariables;
        }
    }
});
</script>
